import { action, computed, observable } from "mobx";

export class ToggleStore {
	@observable elements = observable.set<string>();

	@computed
	get size() {
		return this.elements.size;
	}
	@action.bound
	remove(id: string): void {
		this.elements.delete(id);
	}

	@action.bound
	add(id: string): void {
		this.elements.add(id);
	}

	@action.bound
	toggleCollapse(id: string): void {
		if (this.elements.has(id)) {
			this.elements.delete(id);
		} else {
			this.elements.add(id);
		}
	}

	@action.bound
	clear(): void {
		this.elements.clear();
	}

	@action.bound
	replaceSet(ids: string[]) {
		this.elements = observable.set(ids);
	}
}
